import GoingUtils from "@/utils/goingUtils";
import {GoingNewUtils} from "xmgoing-utils";

export interface IPCSpacePropList {
  propName: string;
  propValues: string;
}


export interface IPcSpaceDomain {
  id?: string;
  spaceType?: string;
  code: string;
  name: string;
  pcSpacePropList?: IPCSpacePropList[];
  remark: string;
  sequence?: number;
  seqType?: string;
  gutterKey: number | string,
  vgutterKey: number | string,
  rows?: Array<any>,
  belongDoor?: string;
  sysSpaceFlag?: number;
  layoutTempId?: string;
  linkUrl?: string;
  linkType?: string;
  contentType?: string;
  borderModuleConfig?: string;
  sectionConfigs?: string;
  appId?: string;
  useAclId?: string;
  useAcl?: string;
  manageAclId?: string;
  manageAcl?: string;
  marginValue?: string;
  marginValueUser?: number;
  headerShowType?: string;
  layout?: string;
}


/**
 * 默认的空间记录信息
 */
export const defSpaceDomainObj: IPcSpaceDomain = {
  "name": "安全信息",
  "code": "adsfas",
  "gutterKey": "12",
  "vgutterKey": "12",
  "remark": "",
  "rows": [{
    "_vid": "inogneegssahness4ljg", "active": false, "children": [{
      "children": [{
        "borderConfig": {
          "width": "100%",
          "ctlName": "borderNoTitle",
          "borderRadius": "smallBorderRadius",
          "height": 200,
          "paddingTb": "small",
          "background": "#FFF",
          "paddingLr": "small",
          "backgroundFlag": true
        },
        "sectionConfig": {
          "ctlName": "lineChar",
          "barColor": "#5470C6",
          "barWidth": "38",
          "seriesFlag": true,
          "seriesPosition": "inside"
        },
        "dataConfig": {
          "sumType": "sum",
          "showType": 0,
          "dataType": "char",
          "userDef": true,
          "xPointId": "label",
          "yPointId": "value"
        },
        "_vid": "vid_1f0ab5993e",
        "moduleName": "containerComponents",
        "componentKey": "lineChar",
        "label": "折线图",
        "adjustPosition": true,
        "focus": false,
        "styles": {
          "display": "flex",
          "justifyContent": "flex-start",
          "paddingTop": "0",
          "paddingRight": "0",
          "paddingLeft": "0",
          "paddingBottom": "0",
          "tempPadding": "0"
        },
        "hasResize": false,
        "props": {},
        "draggable": true,
        "showStyleConfig": true,
        "animations": [],
        "actions": [],
        "events": [],
        "model": {}
      }, {
        "borderConfig": {
          "width": "100%",
          "ctlName": "borderNoTitle",
          "borderRadius": "smallBorderRadius",
          "height": 200,
          "paddingTb": "small",
          "background": "#FFF",
          "paddingLr": "small",
          "backgroundFlag": true
        },
        "sectionConfig": {
          "ctlName": "pieChar",
          "barColor": "#5470C6",
          "barWidth": "38",
          "seriesFlag": true,
          "seriesPosition": "inside"
        },
        "dataConfig": {
          "sumType": "sum",
          "showType": 0,
          "dataType": "char",
          "userDef": true,
          "xPointId": "label",
          "yPointId": "value"
        },
        "_vid": "vid_a4f966cc7b",
        "moduleName": "containerComponents",
        "componentKey": "pieChar",
        "label": "饼图",
        "adjustPosition": true,
        "focus": false,
        "styles": {
          "display": "flex",
          "justifyContent": "flex-start",
          "paddingTop": "0",
          "paddingRight": "0",
          "paddingLeft": "0",
          "paddingBottom": "0",
          "tempPadding": "0"
        },
        "hasResize": false,
        "props": {},
        "draggable": true,
        "showStyleConfig": true,
        "animations": [],
        "actions": [],
        "events": [],
        "model": {}
      }], "active": false, "_vid": "cljambohsslbhlss4knc", "span": 24
    }]
  }],
  "id": "1554340994822963201",
  "updateUser": "1366940185236881410",
  "updateTime": "2022-08-02 13:39:06",
  "status": 0,
  "isDeleted": 0,
  "tenantId": "000000",
  "spaceType": "sysDef",
  "sequence": 123,
  "seqType": "",
  "belongDoor": "",
  "sysSpaceFlag": 0,
  "layoutTempId": "oneColPattern",
  "linkUrl": "",
  "linkType": "sysUrl",
  "contentType": "",
  "borderModuleConfig": "",
  "sectionConfigs": "",
  "dataSourceConfig": "",
  "appId": "",
  "pcSpacePropList": [],
  "useAclId": "",
  "useAcl": "",
  "manageAclId": "",
  "manageAcl": ""
}

/**
 * 空间的配置信息
 */
export const pcSpaceFormConfig = {
  labelSpan: 24,
  fieldAry: [
    {
      id: 'code',
      label: '门户编码',
      rules: [{required: true, message: '类别编码不能为空!'}],
      disabled: true,
      defValue: GoingNewUtils.getUUChar(10)
    },
    {id: 'name', label: '门户名称', rules: [{required: true, message: '类别名称不能为空!'}],},
    {
      id: 'gutterKey', label: '左右间距', defValue: '24', type: 'buttonGroup', options: [
        {label: '小', value: '12'},
        {label: '中', value: '24'},
        {label: '大', value: '32'},
      ]
    },
    {
      id: 'vgutterKey', label: '上下间距', type: 'buttonGroup', defValue: '24', options: [
        {label: '小', value: '12'},
        {label: '中', value: '24'},
        {label: '大', value: '32'},
      ]
    },
    {
      id: 'remark', label: '备注说明', type: 'textarea'
    }
  ]
}
